
import { useNavigate } from "react-router-dom";

export function NoProfileView() {
  const navigate = useNavigate();
  
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-xl font-bold">No profile data found</h1>
        <button 
          onClick={() => navigate('/auth')} 
          className="mt-4 px-4 py-2 bg-purple-600 text-white rounded-md"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}
